import api from '../global/http'
//定义接口  
class API {
    getDemo = params => api('get', 'getDemo', params)
    postDemo = params => api('post', 'postDemo', params)
    // login
    // 文字信息
    getTitleData = params => api('post', '', params,'scan')
    // 轮询二维码登录状态
    getQrcodeState = params => api('get', 'api/v1/qrcode/check_authorized_login', params)
    // 获取二维码数据
    getQrcodeData = params => api('get', 'api/v1/qrcode/login_code', params)

    // 获取手机验证码
    getCode = params => api('post', 'api/v1/sms/send', params,'notoken')
    // 手机验证码登录
    goCodeLogin = params => api('post', 'api/v1/account/mobile_login', params,'notoken')

    // information
    //获取用户资料
    getUserInfo = params => api('get', 'api/v1/user/center', params)
    // 退出登录
    goLogout = params => api('post', 'api/v1/account/logout', params)

    // UserInfo
    // 获取直播列表
    getLiveList = params => api('get', 'api/v1/wow_live/living_list', params)
    // 获取教师待开播数据
    getTeaLiveData = params => api('post', 'getTeaLiveData', params)
    // 验证密码
    enterPass = params => api('post', 'api/v1/live/check_password', params)
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~直播~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // im用户
    showMessageInBox = params => api('get', 'api/v1/live/viewer_list', params);
    // 退出课堂
    quit = params => api('post', 'api/v1/live/end', params);
    //用户列表
    userInfoList = params => api('post', 'userInfoList', params);
    //心跳接口
    videoHeartbeat = params => api('post', 'videoHeartbeat', params);
    //im禁言
    onSpeechBut = params => api('post', 'api/v1/live/forbid_user', params);
    //踢出房间
    onGetOutBut = params => api('post', 'api/v1/live/remove_user', params);
    // 设置管理员
    onAdminBut = params => api('post', 'api/v1/live/set_admin', params);
    //取消管理员
    onAdminNoBut = params => api('post', 'onAdminNoBut', params);
    //获得正在直播的直播数据
    getLivingData = params => api('get', 'api/v1/live/detail', params);
    // 获取直播间参数
    getLiveRoomData = params => api('post', 'getLiveRoomData', params);
    //获取IMusersig
    imDatausersig = params => api('post', 'imDatausersig', params);
    //开启旁路流
    start_mix_transcode_mix = params => api('post', 'api/v1/live/start_mix_transcode', params);
    //进入直播请求数据
    pc_get_video = params => api('post', 'pc_get_video', params);
    //预直播
    pc_add_video = params => api('post', 'pc_add_video', params);
    //直播
    // Live```````````````````````````````````````````````````````````````````````
    // 获取阿里云oss数据
    getAliOss = params => api('get', 'api/v1/oss/token', params)
    // 创建直播
    createLiveRoom = params => api('post', 'api/v1/live/start', params)
    // 获取IMusersig
    getImUsersig = params => api('get', 'api/v1/live/im_user_sig', params)
    // TRTC签名
    geTrtc_user_sig = params => api('get', 'api/v1/live/trtc_user_sig', params)
    // 获取待直播列表
    getMyWaitLiveList = params => api('get', 'api/v1/live/user_future_list', params)
    // 获取今日直播列表
    getMyTodayLiveList = params => api('get', 'api/v1/live/user_today_list', params)
    //LiveItem```````````````````````````````````````````
    // 获取待直播的直播参数
    getWaitLiveItem = params => api('post', 'getWaitLiveItem', params)
    // regression```````````````````````
    // 获取回看链接
    getLookBack = params => api('get', 'api/v1/live/video_detail', params)
    // liveList```````````````````````````````````````
    // 获得直播状态
    getLiveStatus = params => api('post', 'getLiveStatus', params)
    //im发送群聊消息
    send_group_msg = params => api('post','api/v1/im/send_group_msg',params)
    //im发送私聊消息
    send_msg = params => api('post','api/v1/im/send_msg',params)
}

export default new API()